export default function checkFile(file, format) {
  if (!file) return false;
  const allowedFormats = format;
  const fileName = file.name;
  const fileExtension = fileName.split('.').pop().toLowerCase();

  return allowedFormats.includes(fileExtension);
}
